import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { PXFormModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXFormModalWrapper';
import WizardStepDeleteButton from './WizardStepDeleteButton';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();

  async function handleDelete() {
    return resource.delete();
  }

  const onDeleteSuccess = async () => {
    clearModalCollection();
  };

  return (
    <PXFormModalWrapper buttonLabel={resource.attr('primaryActionLabel')}>
      <MetaLayoutRemainingFields />
      {resource.meta().canDelete() ? (
        <WizardStepDeleteButton
          onDelete={handleDelete}
          onDeleteSuccess={onDeleteSuccess}
          dialogProps={{
            title: 'Are you sure?',
            message: 'Removing this item will delete all of its information. This cannot be undone.',
            confirmLabel: 'Remove',
          }}
        />
      ) : null}
    </PXFormModalWrapper>
  );
};

export default Layout;
